import type { IntegrationConnectableNodeData } from './integrationNodeData';

export const mcpSourceTypes = {
  serverUrlIn: 'serverUrl',
  toolNameIn: 'toolName',
  promptIn: 'prompt',
  authTokenIn: 'authToken',
} as const;

export type McpSourceTypes = typeof mcpSourceTypes;

export interface McpCallToolRequestPayload {
  serverUrl?: string;
  integrationId?: string;
  toolName?: string;
  prompt?: string;
  authToken?: string;
  socketId?: string;
  organizationId?: string;
  integrationResource?: string;
  clientRequestId?: string;
  nodeId?: string;
  flowId?: string;
  toolContext?: {
    name: string;
    description?: string;
    inputSchema?: Record<string, unknown>;
  };
}

export type McpNodeData =
  | (IntegrationConnectableNodeData & Record<string, unknown>)
  | undefined;

export interface McpNodeFormState {
  serverUrl: string;
  toolName: string;
  prompt: string;
  authToken: string;
  integrationId: string;
  text: string;
}

function stringFieldFromMcpData(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export function initialMcpFormState(data: McpNodeData): McpNodeFormState {
  return {
    serverUrl: stringFieldFromMcpData(data?.serverUrl),
    toolName: stringFieldFromMcpData(data?.toolName),
    prompt: stringFieldFromMcpData(data?.prompt),
    authToken: stringFieldFromMcpData(data?.authToken),
    integrationId: stringFieldFromMcpData(data?.integrationId),
    text: stringFieldFromMcpData(data?.text),
  };
}
